'use client'

import { FormSearchAndSelect } from '@repo/form-components/FormSearchAndSelect'
import { useThirdPartyFormsStore } from '@repo/store/useThirdPartyFormsStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardPanel } from '@repo/ui/WizardPanel'

type StepProps = {
  wideMode?: boolean
  handlePrevNext: (delta: number) => void
  updateStepState: (changes: { status?: string; statusText?: string }) => void
  testMode?: boolean
}

export const SelectFormStep = ({ wideMode, handlePrevNext, updateStepState }: StepProps) => {
  const { mappedFormData, setMappedFormData } = useThirdPartyFormsStore() as {
    mappedFormData: { formId?: string | null }
    setMappedFormData: (payload: { mappedFormData: Partial<{ formId: string | null }> }) => void
  }

  const handleSelectionChange = (formId: string) => {
    setMappedFormData({ mappedFormData: { formId } })
  }

  const handleContinue = () => {
    updateStepState({ status: 'completed', statusText: 'Complete' })
    handlePrevNext(1)
  }

  return (
    <>
      <WizardPanel data-testid="SelectFormStep">
        <FormSearchAndSelect
          variant="radio"
          selectedFormIds={mappedFormData?.formId ?? ''}
          onSelectionChange={handleSelectionChange}
          hideLinkedToWorktypeCheckbox
        />
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleContinue}
        handleClickBack={() => handlePrevNext(-1)}
        continueButtonText="Map fields"
        continueButtonDisabled={!mappedFormData?.formId}
      />
    </>
  )
}
